import React from "react";

function Interiors() {
  window.scrollTo(0, 0);
  return <div>yolo</div>;
}

export default Interiors;
